import * as React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ru';
import Box from '@mui/joy/Box';
import Sheet from '@mui/joy/Sheet';
import Tooltip from '@mui/joy/Tooltip';
import Typography from '@mui/joy/Typography';
import VideogameAssetIcon from '@mui/icons-material/VideogameAsset';
import { Bot, BotMode, BotModeDescription, BotModeName, BotsListRequest, BotTransferRequest, BotTransferResult } from '../../../models/bot';
import { botsSendSkinsApi, botsListApi } from "../botsApi";
import { NotificationService } from "../../../common/notification";
import Alert from '@mui/material/Alert';
import Divider from '@mui/joy/Divider';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import ModalClose from '@mui/joy/ModalClose';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import ContentCopy from '@mui/icons-material/ContentCopy';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Game } from '../../../models/games';
import { gamesListApi } from '../../games/gamesApi';
import CircularProgress from "@mui/joy/CircularProgress";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Checkbox from '@mui/joy/Checkbox';
import Input from '@mui/joy/Input';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import Button from '@mui/joy/Button';
import Chip from '@mui/material/Chip';
import Table from '@mui/joy/Table';
import Stack from "@mui/joy/Stack";
import IconButton from '@mui/joy/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import BlockIcon from '@mui/icons-material/Block';
import Link from '@mui/joy/Link';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemContent from '@mui/joy/ListItemContent';
import ListDivider from '@mui/joy/ListDivider';
import DebounceInput from '../../../components/debounceInput/DebounceInput';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
export default function Transfer() {
    const [allGames, setAllGames] = React.useState<Game[]>([]);
    const [isSending, setIsSending] = React.useState(false);
    const [selectedGame, setSelectedGame] = React.useState<number>(440);
    const [baseDataLoading, setBaseDataLoading] = React.useState(false);
    const [resultOpen, setResultOpen] = React.useState(false);
    const [selectedDate, setDate] = React.useState<Dayjs | null>(dayjs().endOf('day'));
    const [tradeLink, setTradeLink] = React.useState<string>('');
    const [transferResults, setTransferResults] = React.useState<BotTransferResult[]>([]);
    const [offerLink, setOfferLink] = React.useState<string>('');
    const [selectedBots, setSelectedBots] = React.useState<number[]>([]);
    const [bots, setBots] = React.useState<Bot[]>([]);
    const [botsLoading, setBotsLoading] = React.useState(false);
    const [filtersOpen, setFiltersOpen] = React.useState(false);
    const [filterRequest, setFilterRequest] = React.useState<BotsListRequest>({
            isDisabled: false,
            isBanned: false,
            mode: [BotMode.TF2, BotMode.P2P],
            page: 1,
            count: 100500
        });

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    React.useEffect(() => {
        setBaseDataLoading(true);
        try {
            loadGames().catch(console.error);
        } finally {
            setBaseDataLoading(false);
        }
    }, [])

    React.useEffect(() => {
        if (!filtersOpen) {
            loadData().catch(console.error);
        }
    }, [filterRequest, filtersOpen])

    const loadGames = async () => {
        let result = await gamesListApi();
        if (result.result) {
            setAllGames(result.value!)
        } else {
            NotificationService.alertError("Не удалось загрузить список игр. Попробуйте позже или обратитесь в службу поддержки")
        }
    }

    const renderFilters = () => {
        return (
            <React.Fragment>
                <FormControl size="sm">
                    <FormLabel>Режим работы</FormLabel>
                    <Select
                        size="sm"
                        placeholder="Режим работы"
                        slotProps={{button: {sx: {whiteSpace: 'nowrap'}}}}
                        value={filterRequest.mode?.length === 1 ? filterRequest.mode[0] : -1}
                        onChange={(_, value) => setFilterRequest(prevRequest => ({
                                ...prevRequest,
                                mode: (value ?? 0) > -1 ? [value as BotMode] : [BotMode.TF2, BotMode.P2P]
                            }))}
                    >
                        <Option value={-1}>Все</Option>
                        <Option value={BotMode.TF2}>{BotModeName[BotMode.TF2]}</Option>
                        <Option value={BotMode.P2P}>{BotModeName[BotMode.P2P]}</Option>
                    </Select>
                </FormControl>
            </React.Fragment>
        );
    }

    const applyFilter = async () => {
        setFiltersOpen(false)
        loadData();
    }

    const loadData = async () => {
        setBotsLoading(true)
        try {
            let result = await botsListApi(filterRequest);
            if (result.result) {
                const res = result.value!;
                setBots(res.items)
                setSelectedBots([]);
            } else {
                NotificationService.alertError("Пожалуйста попробуйте позже или обратитесь в службу поддержки")
            }
        } finally {
            setBotsLoading(false)
        }
    }

    const sendSkinsByDate = async () => {
        setIsSending(true);
        setTransferResults([]);
        try {

            const request = selectedBots.map(e => new BotTransferRequest(e, selectedGame, tradeLink, selectedDate?.toDate()));
            let result = await botsSendSkinsApi(request);
            if (result.result) {
                setTransferResults(result.value ?? []);
                setResultOpen(true);
            } else {
                NotificationService.alertError("Пожалуйста попробуйте позже или обратитесь в службу поддержки")
            }
        } finally {
            setIsSending(false);
        }
    }

    const copyOfferLink = () => {
        navigator.clipboard.writeText(offerLink);
        NotificationService.alertSuccess("Скопировано!");
    }

    return (
        <React.Fragment>
            <Typography level="title-md">Передача скинов</Typography>
            <Alert variant="outlined" severity="info">Заказы по переданным скинам будут завершены со статусом 'Успех'</Alert>
            <Typography level="body-sm">Выберите дату, скины полученные по которую (включительно), должны быть переданы, и укажите торговую ссылку получателя.</Typography>
            {isSending || baseDataLoading
                ? <CircularProgress/>
                : <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center', p: 2, bgcolor: 'background.level1', borderRadius: '8px', mb: 3 }}>
                    <FormControl size="sm" sx={{ mt: 1, minWidth: 120 }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
                            <DatePicker
                                sx={{mt: 1, maxWidth: 200, flex: 1}}
                                label="Дата до"
                                value={selectedDate}
                                onChange={(newValue) => setDate(newValue)}
                            />
                        </LocalizationProvider>
                    </FormControl>

                    <FormControl size="sm" sx={{
                        justifyContent: 'start',
                        minWidth: {xs: '100%', md: 'auto'},
                    }}>
                        <FormLabel>Игра</FormLabel>
                        <Select size="sm"
                                startDecorator={<VideogameAssetIcon/>}
                                placeholder="Игра"
                                value={selectedGame}
                                onChange={(_, value) => setSelectedGame(value ?? -1)}>
                            {allGames.map((p) => <Option key={p.id} value={p.id}>{p.name}</Option>)}
                        </Select>
                    </FormControl>

                    <FormControl sx={{mt: 0, minWidth: '100%', flex: 1}} size="sm">
                        <FormLabel>Торговая ссылка получателя</FormLabel>
                        <Input size="sm" placeholder="Tradelink"
                            value={tradeLink} onChange={(event) => setTradeLink(event.target.value)}/>
                    </FormControl>
                    
                </Box>}
            <Button color="primary" onClick={sendSkinsByDate}
                    disabled={isSending || selectedDate === undefined || tradeLink.length === 0 || selectedBots.length === 0}>
                Передать скины
            </Button>

            <Typography level="title-sm" sx={{ mt:2}}>
                Выберите ботов для передачи скинов (отображаются только включенные боты без бана, предназначенные для обмена)
            </Typography>

            <Sheet
                className="SearchAndFilters-mobile"
                sx={{display: {xs: 'flex', sm: 'none'}, my: 1, gap: 1}}
            >
                <Chip label={bots.length === selectedBots.length ? "Снять выбор" : "Выбрать все"}
                      variant="outlined"
                      color={bots.length > 0 ? "success" : "default"}
                      disabled={bots.length <= 0}
                      icon={bots.length === selectedBots.length ? <RemoveDoneIcon fontSize='medium' /> : <DoneAllIcon fontSize='medium' />}
                      onClick={bots.length === selectedBots.length
                        ? async () => setSelectedBots([])
                        : async () => setSelectedBots(bots.map(e => e.id))}/>
                <DebounceInput
                    size="sm"
                    placeholder="Поиск"
                    startDecorator={<SearchIcon/>}
                    sx={{flexGrow: 1}}
                    debounceTimeout={1000}
                    handleDebounce={(val) => setFilterRequest(prevRequest => ({
                        ...prevRequest,
                        search: val || undefined
                    }))}
                />
                <IconButton
                    size="sm"
                    variant="outlined"
                    color="neutral"
                    onClick={() => setFiltersOpen(true)}
                >
                    <FilterAltIcon/>
                </IconButton>
                <Modal open={filtersOpen} onClose={() => setFiltersOpen(false)}>
                    <ModalDialog aria-labelledby="filter-modal" layout="fullscreen">
                        <ModalClose/>
                        <Typography id="filter-modal" level="h2">
                            Фильтры
                        </Typography>
                        <Divider sx={{my: 2}}/>
                        <Sheet sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                            {renderFilters()}
                            <Button color="primary" onClick={applyFilter}>
                                Применить
                            </Button>
                            <Button color="neutral" onClick={() => setFiltersOpen(false)}>
                                Закрыть
                            </Button>
                        </Sheet>
                    </ModalDialog>
                </Modal>
            </Sheet>
            <Box
                className="SearchAndFilters-tabletUp"
                sx={{
                    borderRadius: 'sm',
                    py: 2,
                    display: {xs: 'none', sm: 'flex'},
                    flexWrap: 'wrap',
                    gap: 1.5,
                    alignItems: 'end',
                    '& > *': {
                        minWidth: {xs: '120px', md: '160px'},
                    },
                }}
            >
                <FormControl sx={{flex: 1}} size="sm">
                    <FormLabel>Поиск ботов</FormLabel>
                    <DebounceInput
                        size="sm"
                        placeholder="Поиск"
                        startDecorator={<SearchIcon/>}
                        debounceTimeout={1000}
                        handleDebounce={(val) => setFilterRequest(prevRequest => ({
                            ...prevRequest,
                            search: val || undefined
                        }))}
                    />
                </FormControl>
                {renderFilters()}
                <Chip label={bots.length === selectedBots.length ? "Снять выбор" : "Выбрать все"}
                      variant="outlined"
                      color={bots.length > 0 ? "success" : "default"}
                      disabled={bots.length <= 0}
                      icon={bots.length === selectedBots.length ? <RemoveDoneIcon fontSize='medium' /> : <DoneAllIcon fontSize='medium' />}
                      onClick={bots.length === selectedBots.length
                        ? async () => setSelectedBots([])
                        : async () => setSelectedBots(bots.map(e => e.id))}/>
            </Box>

            {botsLoading ?
                <CircularProgress/> :
                <Box
                    component="main"
                    className="MainContent"
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: 0,
                        gap: 1,
                    }}
                >
                    <Sheet
                        className="OrderTableContainer"
                        variant="outlined"
                        sx={{
                            display: {xs: 'none', sm: 'initial'},
                            width: '100%',
                            borderRadius: 'sm',
                            flexShrink: 1,
                            overflow: 'auto',
                            minHeight: 0,
                        }}
                    >
                        <Table
                            aria-labelledby="tableTitle"
                            stickyHeader
                            hoverRow
                            sx={{
                                '--TableCell-headBackground': 'var(--joy-palette-background-level1)',
                                '--Table-headerUnderlineThickness': '1px',
                                '--TableRow-hoverBackground': 'var(--joy-palette-background-level1)',
                                '--TableCell-paddingY': '4px',
                                '--TableCell-paddingX': '8px',
                            }}
                        >
                            <thead>
                            <tr>
                                <th style={{width: 100, padding: '12px 6px'}}>Id</th>
                                <th style={{width: 140, padding: '12px 6px'}}>Steam Id</th>
                                <th style={{width: 240, padding: '12px 6px'}}>Имя (никнейм)</th>
                                <th style={{width: 140, padding: '12px 6px'}}>Прокси</th>
                                <th style={{width: 140, padding: '12px 6px'}}>Режим работы</th>
                                <th style={{width: 50, padding: '12px 6px'}}></th>
                            </tr>
                            </thead>
                            <tbody>
                            {bots.map((row) => {
                                return(
                                <tr key={row.id.toString()} style={row.bannedAt ? {backgroundColor: 'red'} : {}}>
                                    <td>
                                        <Link
                                            level="body-sm"
                                            href={`/app/bots/${row.id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {row.id.toString()}
                                        </Link>
                                    </td>
                                    <td>
                                        <Stack spacing={.5} direction={'column'}>
                                            <Link
                                                underline="hover"
                                                href={`https://steamcommunity.com/profiles/${row.steamId}/`}
                                                target="_blank"
                                                level="body-xs"
                                            >
                                                {row.steamId.toString()}
                                            </Link>
                                            <Typography level="body-xs" textColor={'background.backdrop'}>(level #{row.level})</Typography>
                                        </Stack>
                                    </td>
                                    <td>
                                        <Stack spacing={.5} direction={'column'}>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                {row.avatar && (
                                                    <Box component="img" src={row.avatar} sx={{ height: "20px", width: "20px", borderRadius: '50%' }} />
                                                )}
                                                <Typography level="body-xs">
                                                    {row.nickName ? `${row.userName} (${row.nickName})` : row.userName}
                                                </Typography>
                                            </Stack>
                                            <Typography level="body-xs" textColor={'background.backdrop'}>{row.comment}</Typography>
                                        </Stack>
                                    </td>
                                    <td>
                                        <Typography level="body-xs">{row.proxyAddress}</Typography>
                                    </td>
                                    <td>
                                        <Tooltip title={BotModeDescription[row.mode]}>
                                            <Typography level="body-xs">{BotModeName[row.mode]}</Typography>
                                        </Tooltip>
                                    </td>
                                    <td>
                                        <Checkbox checked={selectedBots.some(e => e === row.id)}
                                                  onChange={(event) => setSelectedBots(event.target.checked ?
                                                  [ ...selectedBots, row.id] : selectedBots.filter(e => e !== row.id)
                                        )}/>
                                    </td>
                                </tr>)
                            })}
                            </tbody>
                        </Table>
                    </Sheet>

                    <Box sx={{display: {xs: 'block', sm: 'none'}}}>
                        {bots.map((listItem) => {
                            return(
                            <List key={listItem.id.toString()} size="sm" sx={{'--ListItem-paddingX': 0}}>
                                <ListItem
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'start',
                                    }}
                                >
                                    <ListItemContent sx={{display: 'flex', gap: 2, alignItems: 'start'}}>
                                        <div>
                                            <Link
                                                level="body-sm"
                                                href={`/app/bots/${listItem.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <Typography gutterBottom sx={{fontWeight: 600}}>
                                                    {listItem.steamId.toString()} (#{listItem.id.toString()})
                                                </Typography>
                                            </Link>
                                            <Typography level="body-xs">Level #{listItem.level}</Typography>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                {listItem.avatar && (
                                                    <Box component="img" src={listItem.avatar} sx={{ height: "20px", width: "20px", borderRadius: '50%' }} />
                                                )}
                                                <Typography level="body-xs">
                                                    {listItem.nickName ? `${listItem.userName} (${listItem.nickName})` : listItem.userName}
                                                </Typography>
                                            </Stack>
                                            <Typography level="body-xs">Прокси: {listItem.proxyAddress}</Typography>
                                            <Typography level="body-xs">Режим работы: {BotModeDescription[listItem.mode]}</Typography>
                                            {!listItem.comment ? <></> : <Typography level="body-xs">Комментарий: {listItem.comment}</Typography>}
                                        </div>
                                    </ListItemContent>
                                    <Chip
                                        variant="outlined"
                                        size="small"
                                        icon={listItem.isDisabled ? <BlockIcon/> : <CheckRoundedIcon/>}
                                        color={listItem.isDisabled ? 'error' : 'success'}
                                        label={listItem.isDisabled ? "Выключен" : "Активен"}
                                    />
                                    {listItem.avatar
                                        ? <Box component="img" src={listItem.avatar} sx={{ height: "30px", width: "auto" }} />
                                        : <></>}
                                    <Checkbox checked={selectedBots.some(e => e === listItem.id)}
                                              onChange={(event) => setSelectedBots(event.target.checked ?
                                              [ ...selectedBots, listItem.id] : selectedBots.filter(e => e !== listItem.id))}
                                    />
                                </ListItem>
                                <ListDivider/>
                            </List>)
                        })}
                    </Box>
                </Box>
            }

            <Dialog
                open={resultOpen}
                fullScreen={fullScreen}
                onClose={() => setResultOpen(false)}
            >
                <DialogTitle>Результаты передачи</DialogTitle>
                <DialogContent>
                    <Box
                        noValidate
                        component="form"
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            overflowY: 'scroll',
                            overflowX: 'hidden'
                        }}
                    >
                        {transferResults.map(row => (
                        <Stack spacing={.5} direction={'row'} alignItems={'center'} sx= {{ mt:1 }}>
                            <Typography level="body-xs" >Бот #{row.botId}</Typography>
                            {row.success
                                ? (row.steamOfferId ?? 0) > 0
                                    ? (<FormControl sx={{mt: 0, minWidth: '80%', maxWidth: '80%', flex: 1}} size="sm">
                                        <OutlinedInput
                                            type='text'
                                            sx={{boxSizing: 'border-box', overflow: 'hidden'}}
                                            size='small'
                                            readOnly
                                            value={`https://steamcommunity.com/tradeoffer/${row.steamOfferId}`}
                                            endAdornment={
                                            <InputAdornment position="end">
                                                <Tooltip title='Копировать'>
                                                    <IconButton  onClick={() => {
                                                                    setOfferLink(`https://steamcommunity.com/tradeoffer/${row.steamOfferId}`);
                                                                    copyOfferLink();
                                                                }}>
                                                        <ContentCopy />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                            }
                                        />
                                    </FormControl>)
                                    : (<Typography level="body-xs" >Обмен был создан, но ссылку на обмен получить не удалось.</Typography>)
                                : <Typography level="body-xs">Ошибка создания обмена: {row.errorMessage ?? 'Unhandled error'}</Typography>}
                        </Stack>))}                        
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="neutral" onClick={() => setResultOpen(false)}>Закрыть</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}